/* ###############  DEPENDENCIAS ##################### */
import forge from 'node-forge'

/* ###############  VARIABLES ######################## */
export let elementosDeFirma = {
    message: '',
    PKCS7creado: '',
    extFileUpload: ''
}

let byteToHex = [];

(() => {
    for (let n = 0; n <= 0xff; ++n) {
        let hexOctet = n.toString(16).padStart(2, "0");
        byteToHex.push(hexOctet);
    }
})();

/* ###############  FUNCIONES ####################### */
 /**
 * Funcion encargada de convertir un arrayBuffer en hexadecimal
 * @param {Array} arrayBuffer [buffer de archivo]
 * @returns {Array} hexOctets [array hexadecimal del archivo]
 */
const ConvertToHex = async ({ arrayBuffer }) => {
    const buff = new Uint8Array(arrayBuffer);
    let hexOctets = []; 

    for (let i = 0; i < buff.length; ++i) 
        hexOctets.push(byteToHex[buff[i]]);

    return hexOctets.join("");
}

 /**
 * Funcion encargada de leer un archivo
 * @param {Object} ctrlFile [File]
 * @returns {Promise} proceso [valor hexadecimal del contenido del archivo]
 */
const SelectFileSign = async ({ ctrlFile }) => { 
    return new Promise(async (resolve, reject) => {
        let proceso = { conError: true, errorMsj: '' }
        try {
            const FILE = ctrlFile.files[0];

            if(FILE != null) {
                const NOMBRE_ARCHIVO = FILE.name;
                elementosDeFirma.extFileUpload = NOMBRE_ARCHIVO.split('.')[1];   
            }

            let fileReader = new FileReader();
            fileReader.readAsArrayBuffer(FILE); 

            fileReader.onload = async (e) => {
                let bufferFile = e.target.result;       
                elementosDeFirma.message = await Promise.resolve(ConvertToHex({ arrayBuffer: bufferFile }));
                proceso.conError = false;
                resolve(proceso)
                /* console.info('SelectFileSign::finalizado::',elementosDeFirma.message); */
            };
        }
        catch(error) {
            proceso.errorMsj = error;
            console.log('Excp::SelectFileSign::msj::', error);
        }
    });
}

/**
 * Funcion encargada de leer un archivo PFX
 * @param {Object} ctrlFile [File]
 * @returns {Promise} procesoTerminado [valor del estatus de la lectura]
 */
const SelectPfx = ({ pfxFile }) => { 
    let procesoTerminado = false;
    const EXTENSION_VALIDA = 'pfx';
    const FILE_PFX = pfxFile.files[0];

    if(NoEsNulo({ campo: FILE_PFX })) {
        const NOMBRE_ARCHIVO = FILE_PFX.name;
        const EXTENSION = NOMBRE_ARCHIVO.split('.')[1];

        procesoTerminado = (NoEsNulo({ campo: EXTENSION }) && EXTENSION == EXTENSION_VALIDA);
        /* if(NoEsNulo({ campo: EXTENSION }) && EXTENSION == EXTENSION_VALIDA) {
            procesoTerminado = NoEsNulo({ campo: elementosDeFirma.message });
        } */
    }
    /* console.info('SelectPfx::finalizado::'); */
    return procesoTerminado;
}

/**
 * Funcion encargada de crear las llave prvadaPEM y el certificadoPEM
 * @param {Object} ctrlFile [Archivo pfx]
 * @param {String} password [contraseña de la llave pfx]
 * @returns {Promise} procesoTerminado [valor de las llaves encriptadas]
 */
const OpenPfx = async ({ ctrlFile, password }) => { 
    return new Promise((resolve, reject) => {
        let proceso = { conError: true, errorMsj: '', respuesta: { certPEM: null, privateKeyPem: null, message: null } };
        try {
            //Se Lee el archivo pfx
            let file = ctrlFile.files[0];
            let reader = new FileReader();
            reader.readAsArrayBuffer(file);

            reader.onload = async (e) => { 
                try {
                    let bufferFile = e.target.result;
                    let pkcs12Der = forge.util.binary.raw.encode(new Uint8Array(bufferFile));
                    let p12Asn1 = forge.asn1.fromDer(pkcs12Der);
                    let _contentFileP12 = forge.pkcs12.pkcs12FromAsn1(p12Asn1, password);
            
                    //Se Obtienen La llave Privada y el Certificado del Archivo pfx
                    let certBags = _contentFileP12.getBags({ bagType: forge.pki.oids.certBag });
                    let pkeyBags = _contentFileP12.getBags({ bagType: forge.pki.oids.pkcs8ShroudedKeyBag });
                    let certBag = certBags[forge.pki.oids.certBag][0];
                    let keybag = pkeyBags[forge.pki.oids.pkcs8ShroudedKeyBag][0];
            
                    let privateKeyPem = forge.pki.privateKeyToPem(keybag.key);
                    let certPEM = forge.pki.certificateToPem(certBag.cert);
            
                    privateKeyPem = privateKeyPem.replace(/\r\n/g, '\n');
                    certPEM = certPEM.replace(/\r\n/g, '\n');
                    
                    proceso.respuesta = {
                        certPEM: certPEM,
                        privateKeyPem: privateKeyPem,
                        message: elementosDeFirma.message
                    }
                    /* elementosDeFirma.PKCS7creado = CreatePKCS7({ certPEM: certPEM, privateKeyPEM: privateKeyPem, message: elementosDeFirma.message });
                    console.log('certPEM::',certPEM);
                    console.log('privateKeyPem::',privateKeyPem);
                    console.log('message::',elementosDeFirma.message);
                    proceso.conError = NoEsNulo({ campo: elementosDeFirma.PKCS7creado }); */
                    proceso.conError = false;
                    resolve(proceso)
                }
                catch(error) {
                    proceso.errorMsj = error.toString();
                    resolve(proceso);
                }
            };
        }
        catch(error) {
            proceso.errorMsj = error;
            console.log('Excp::SelectFileSign::msj::', error);
            reject(proceso);
        }
    });
}

/* SE PASO DIRECTAMENTE AL COMPONENTE */
/* const CreatePKCS7 = ({ certPEM, privateKeyPEM, message }) => { debugger
    let pkcs7 = null;
    var param = {
        content: { hex: message },
        certs: [certPEM],
        signerInfos: [{
            hashAlg: 'sha256',
            sAttr: {
                SigningTime: {}
            },
            signerCert: certPEM,
            sigAlg: 'SHA256withRSA',
            signerPrvKey: privateKeyPEM
        }]
    };  
    
    try {
        var signedData = KJUR.asn1.cms.CMSUtil.newSignedData(param);
        console.log(signedData);
        pkcs7 = RemoveCMSHeader(signedData.getPEM()); 
    } catch (error) {
        console.error(error);
    }
    return pkcs7;
} */

/**
 * Funcion encargada de remover los headers del pkcs7 de la firma
 * @param {String} cms [Archivo pfx]
 * @returns {String} pkcs7 []
 */
const RemoveCMSHeader = ({ cms }) => {
    let pkcs7 = '';
    try{
        pkcs7 = cms.replace("-----END CMS-----", "").replace("-----BEGIN CMS-----", "").replace(/(\r\n|\n|\r)/gm, "");
    }
    catch (error) {
        console.error(error);
    }    
    return pkcs7;
}

/**
 * Funcion encargada de validar si un valor esta nulo
 * @param {any} campo [campo a evaluar]
 * @returns {Boolean} esValido [indicador si el campo no esta nulo]
 */
const NoEsNulo = ({ campo }) => { 
    let esValido = false
    if(typeof campo === 'string' || campo instanceof String) {
        // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
        if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
            esValido = true;
        }
    }
    else if (typeof campo === 'number' || campo instanceof Number) {
        // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
        if (campo != null && campo != undefined && campo > 0) {
            esValido = true;
        }
    }
    else if (typeof campo === 'array' || campo instanceof Array) {
        // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
        if (campo != null && campo != undefined && campo.length > 0) {
            esValido = true;
        }
    }
    else {
        if (campo != null && campo != undefined) {
            esValido = true;
        }
    }
    return esValido;
}

const ObtenerStringDeBase64 = async ({ base64STR }) => {
    let procesoDecodificacion = { error: { activo: true, mensaje: '' }, mensajeDeCodificado: null };
    try {
        if(NoEsNulo({ campo: base64STR })) {
            procesoDecodificacion.mensajeDeCodificado = window.atob(base64STR);
            procesoDecodificacion.error.activo = false;
        }
    }
    catch(e) {
        console.error(e);
    }
    return procesoDecodificacion;
}

const ObtenerHexDeBase64 = async ({ base64STR }) => {
    let procesoDecodificacion = { error: { activo: true, mensaje: '' }, hexadecimal: '' };
    try {
        let base64Decodificado = window.atob(base64STR);
        for (let i = 0; i < base64Decodificado.length; i++) {
            let hex = base64Decodificado.charCodeAt(i).toString(16);
            procesoDecodificacion.hexadecimal += (hex.length === 2 ? hex : '0' + hex);
        }
        procesoDecodificacion.error = false;
    }
    catch(e) {
        console.error(e);
    }
    return procesoDecodificacion;
}

export {  ConvertToHex, SelectFileSign, SelectPfx, OpenPfx, CreatePKCS7, RemoveCMSHeader, ObtenerStringDeBase64, ObtenerHexDeBase64  };






// WEBPACK FOOTER //
// ./src/components/FirmaElectronica/FirmaMultiple/funciones/ClienteFunciones.js